import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

const LegalFeedback = ({
  dislikeOpen,
  handleClose,
  dislikeHandler,
}: {
  dislikeOpen: boolean;
  handleClose: () => void;
  dislikeHandler: (reason?: string) => void;
}) => {
  const [dislikeReason, setDislikeReason] = useState("");
  return (
    <Dialog
      open={dislikeOpen}
      onClose={handleClose}
      PaperProps={{ sx: { width: "50%" } }}
    >
      <DialogTitle>Please enter your feedback</DialogTitle>

      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Message"
          type="text"
          fullWidth
          multiline
          rows={4}
          value={dislikeReason}
          onChange={(e) => setDislikeReason(e.target.value)}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} sx={{ color: "black" }}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            setDislikeReason("");
            dislikeHandler(dislikeReason);
          }}
          variant="contained"
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LegalFeedback;
